module.exports = __webpack_public_path__ + "static/img/rencai-02.e6455f5a.png";